// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-o_fb","advertDetailService__price":"c-o_fc"};